
const mutations = {
  _SAVE_DOCUMENT_REPOS: 'SAVE_DOCUMENT_REPOS',
  _SAVE_DOCUMENT_REPO: 'SAVE_DOCUMENT_REPO',
  _SAVE_DOCUMENT_REPO_COMMITS: 'SAVE_DOCUMENT_REPO_COMMITS',
  _SAVE_DOCUMENT_REPO_COMMIT: 'SAVE_DOCUMENT_REPO_COMMIT',
  _SAVE_DOCUMENT_REPO_CHART_TAB: 'SAVE_DOCUMENT_REPO_CHART_TAB',
};

export default {
  mutations,
};
